import React from "react";

// hooks
import { useSelector } from "react-redux";
import { useSearchBar } from "core/SearchBar/context/useSearchBar.js";
import { useRestoreStyleFilters } from "frontend/ssr/hooks/useRestoreStyleFilters";

// redux
import { getStyleParams } from "frontend/store/browse";

// component
export const StyleHiddenInputs = () => {
    const {
        dropDown: {
            selectedOption: { searchParamKey },
        },
    } = useSearchBar();
    useRestoreStyleFilters();

    // NOTE: SearchForm is sometimes used outside Redux context, so data may be null
    const styleParams = useSelector(getStyleParams) || {};

    if (searchParamKey !== "icons") return null;

    const isStyle = styleParams?.style;
    const isWeight = styleParams?.weight;
    const isNounStudio = styleParams?.nounstudio;

    return (
        <>
            {isStyle && <input type="hidden" name="style" value={styleParams.style} />}
            {isWeight && <input type="hidden" name="weight" value={styleParams.weight} />}
            {isNounStudio && (
                <input type="hidden" name="nounstudio" value={styleParams.nounstudio} />
            )}
        </>
    );
};

export default StyleHiddenInputs;
